export const base: string = "#4b2e6e"

// Video background theme configurations
export const videoBackground = {
  blur: {
    default: 8,
    light: 4,
    heavy: 12,
    mobile: 6, // Slightly less blur on mobile for better performance
  },
  opacity: {
    default: 1,
    subtle: 0.7,
    faint: 0.4,
    mobile: 0.8, // Slightly reduced opacity on mobile
  },
  scroll: {
    // Landscape/desktop settings
    threshold: 150, // Start fade after Xpx scroll
    fadeDistance: 250, // Complete fade over Xpx
    duration: 0.8, // Animation duration in seconds

    // Portrait-specific settings (earlier fade)
    portrait: {
      threshold: 250, // Start fade after Xpx scroll (earlier)
      fadeDistance: 350, // Complete fade over Xpx (faster)
    },
  },
} as const

// Media queries for consistent responsive breakpoints
export const breakpoints = {
  mobile: "(max-width: 768px)",
  tablet: "(min-width: 769px) and (max-width: 1024px)",
  desktop: "(min-width: 1025px)",
  smallMobile: "(max-width: 480px)",
  largeMobile: "(min-width: 481px) and (max-width: 768px)",
  portrait: "(orientation: portrait)",
  landscape: "(orientation: landscape)",
  reduceMotion: "(prefers-reduced-motion: reduce)",
  touchDevice: "(hover: none) and (pointer: coarse)",
} as const

// Z-index scale for layering
export const zIndex = {
  videoBackground: -1,
  logo: 1,
  introText: 2,
  overlay: 10,
  modal: 100,
} as const
